import { Component, h, ComponentInterface, Prop, Element, State } from '@stencil/core';
import { guid } from 'utils';


@Component({
	tag: 'kdx-team-members',
	styleUrl: 'kdx-team-members.scss',
	shadow: false
})
export class StTeamMembers implements ComponentInterface {

	@Element() root: HTMLElement;

	@State() expanded: boolean = false;
	@State() guid = guid();

	@Prop() ariaLabel: string;
	@Prop() fade: string = 'false'
	@Prop() ctaId = 'load-more-' + guid();

	expandModule(event: Event) {
		event.preventDefault();
		this.expanded = !this.expanded;
		const element = (document.getElementById(this.guid) as HTMLElement);
		const elementScrollHeight = element.scrollHeight;
		
		if (!this.expanded) {
			if (window.innerWidth > 991.8) {
				document.getElementById(this.guid).style.maxHeight ='1068px';
			} else {
				document.getElementById(this.guid).style.maxHeight ='1500px';

				element.scrollIntoView();
			}
		} else {
			document.getElementById(this.guid).style.maxHeight = elementScrollHeight.toString() + 'px';
		}
	};

	componentDidLoad() {
		const cards = document.querySelectorAll('.kdx-team-card').length;

		if (cards <= 4){ 
			this.fade = 'false';
		};
	};

	render() {
		return (
		<section id={this.guid} class={`kdx-team-members ${this.expanded ? `expanded` : ''} ${this.fade === 'true' ? `fade-active` : ``}`} aria-label={this.ariaLabel}>
			<div class="container-fluid my-4">
				<slot />

				{(this.fade.toLowerCase() != 'false') && (
					<a id={this.ctaId} href="#" class={`load-more-btn btn btn-link ${this.expanded ? 'collapsed' : ''}`} aria-label="A label for this item" onClick={this.expandModule.bind(this)}>
						{this.expanded ? `Show Less` : 'Load More'}
						<div>
							<kdx-icon icon='chevron-down'></kdx-icon>
						</div>
					</a>
				)}
			</div>
		</section>
		);
	}
};